import { FormGroup, FormControl } from '@angular/forms';
import { SharedFormValidators } from '@shared-libs/form-validators';
import { IFormGroup } from '@shared-libs/interfaces';

export class ResetFormFactory {
	public static create(): IFormGroup<{ username: string }> {
		return new FormGroup({
			username: new FormControl('', [SharedFormValidators.required]),
		}) as IFormGroup;
	}

	public static getValue(form: IFormGroup<{ username: string }>): { username: string } {
		form.value.username = form.value.username.trim();
		return form.value;
	}
}
